import React, { HTMLAttributes } from 'react';

import { colors } from '../../styles/tokens';
import { Container } from './styles';

interface IconProps extends HTMLAttributes<HTMLSpanElement> {
  name: string;
  size?: number;
  color?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 24,
  color = colors.onSurface,
  className,
  ...rest
}) => {
  return (
    <Container
      size={size}
      color={color}
      className={`material-symbols-outlined ${className || ''}`}
      {...rest}
    >
      {name}
    </Container>
  );
};

export { Icon };
